import script from "./CertificationsSection.vue?vue&type=script&setup=true&lang=js"
export * from "./CertificationsSection.vue?vue&type=script&setup=true&lang=js"

import "./CertificationsSection.vue?vue&type=style&index=0&id=5fc6a637&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fc6a637"]])

export default __exports__